(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rokit-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
    console.log("%c BUILD SLIDER ", "border-radius:5px; background: red; color: white");

    /*
    var elem = document.querySelector('.recently-viewed .grid');
    var flkty = new Flickity( elem, {
      // options
      groupCells: true,
      contain: true,
      freeScroll: true,
      cellAlign: 'left',
      pageDots: false
    });

    window.addEventListener('resize', function(event) {
      flkty.resize();
    }, true);
    */
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rokit-recommendations"]) return;
  try {
    
  const handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;

    observer.unobserve(productRecommendationsSection);

    const url = productRecommendationsSection.dataset.url;

    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('.product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          productRecommendationsSection.innerHTML = recommendations.innerHTML;
          console.log("%c BUILD SLIDER ", "border-radius:5px; background: red; color: white");

          var elem = document.querySelector('.product-recommendations .grid');
          var flkty = new Flickity( elem, {
            // options
            groupCells: true,
            contain: true,
            freeScroll: true,
            cellAlign: 'left',
            pageDots: false
          });

          window.addEventListener('resize', function(event) {
            flkty.resize();
          }, true);

          console.log("%c Loaded recommendations ", "border-radius:5px; background: red; color: white");
          if (typeof ReloadSmartWishlist !== "undefined" && typeof ReloadSmartWishlist === "function") {
            ReloadSmartWishlist();
          }          
        }
      })
      .catch(e => {
        console.error(e);
      });
  };

  const productRecommendationsSection = document.querySelector('.product-recommendations');
  const observer = new IntersectionObserver(handleIntersection, {rootMargin: '0px 0px 200px 0px'});

  observer.observe(productRecommendationsSection);

  } catch(e) { console.error(e); }
})();
})();
